function Ebill(props) {
  return <h1>Tra cứu hóa đơn</h1>;
}

export default Ebill;
